import { fetchWithCache, getCachedData } from "../services/apiService";

export const getAllAdvertisements = async () => {
  // Return cached data immediately if available
  const cached = getCachedData("/api/advertisement/getAllAdvertisements", {});

  try {
    const data = await fetchWithCache(
      "/api/advertisement/getAllAdvertisements",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    return cached || [];
  }
};
